import { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import classNames from 'classnames/bind';

import styles from './styles.scss';

let cx = classNames.bind(styles);

class ReviewInformationBlock extends Component {
  render() {
    let { style, blockAction, children, type, onClick, title, capitalize } = this.props;

    style = style || 'blue';

    if (blockAction) {
      blockAction = (
        <div className="blockAction">
          <a onClick={(e) => { e.preventDefault(); onClick() }} href="/">{blockAction}</a>
        </div>
      );
    }
    if (title) {
      title = <div className="title">{title}</div>;
    }

    let className = cx({
      reviewInformationBlock: true,
      [`${style}`]: true,
      [`${type}`]: type,
      [`capitalize`]: capitalize,
    });

    return (
      <div className={classnames(className)}>
        {title}
        {children}
        {blockAction}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    style: state.configuration.style,
  };
};

export default connect(mapStateToProps)(ReviewInformationBlock);
